import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ContactInfoCardDataType } from 'typings/form';

interface ContactInfoState {
  contactInfoFields: Array<ContactInfoCardDataType>;
  editId: string | null;
  optionType: string | null;
  editOptionType: string | null;
  isChanged: boolean;
}

const initialState: ContactInfoState = {
  contactInfoFields: [],
  editId: null,
  optionType: null,
  editOptionType: null,
  isChanged: false,
};

export const contactFieldManagerSlice = createSlice({
  name: 'contactFieldManager',
  initialState,
  reducers: {
    addContactInfoField(state, action: PayloadAction<ContactInfoCardDataType>) {
      state.isChanged = true;
      state.contactInfoFields.unshift(action.payload);
    },
    updateContactInfoField(state, action: PayloadAction<ContactInfoCardDataType>) {
      state.isChanged = true;
      state.contactInfoFields = state.contactInfoFields.map((field) =>
        field.id === action.payload.id ? action.payload : field
      );
    },
    setContactInfoFields(state, action: PayloadAction<ContactInfoCardDataType[]>) {
      state.contactInfoFields = action.payload;
    },
    removeContactInfoField(state, action: PayloadAction<string>) {
      state.isChanged = true;
      state.contactInfoFields = state.contactInfoFields.filter((_field) => _field.id !== action.payload);
    },
    resetContactInfoFields(state) {
      state.contactInfoFields = initialState.contactInfoFields;
    },
    setEditId(state, action) {
      state.editId = action.payload;
    },
    resetEditId(state) {
      state.editId = null;
    },
    setOptionType(state, action) {
      state.optionType = action.payload;
    },
    resetOptionType(state) {
      state.optionType = null;
    },
    setEditOptionType(state, action) {
      state.editOptionType = action.payload;
    },
    resetEditOptionType(state) {
      state.editOptionType = null;
    },
    resetIsChanged(state) {
      state.isChanged = false;
    },
  },
});

export const {
  addContactInfoField,
  resetContactInfoFields,
  removeContactInfoField,
  updateContactInfoField,
  setContactInfoFields,
  setEditId,
  resetEditId,
  setOptionType,
  resetOptionType,
  setEditOptionType,
  resetEditOptionType,
  resetIsChanged,
} = contactFieldManagerSlice.actions;
export default contactFieldManagerSlice.reducer;
